export default __webpack_public_path__ + "static/media/collectEmail.f5646215.gif";